(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function() {
  var filterToggle = document.getElementById('mc-filter-toggle');
  var filterDrawer = document.getElementById('mc-filter-drawer');
  var filterOverlay = document.getElementById('mc-filter-overlay');
  var filterClose = document.getElementById('mc-filter-close');
  var filterForm = document.getElementById('mc-filter-form');
  var sortToggle = document.getElementById('mc-sort-toggle');
  var sortDropdown = document.getElementById('mc-sort-dropdown');

  function openFilter() {
    filterDrawer.classList.add('is-open');
    filterOverlay.classList.add('is-open');
    filterDrawer.setAttribute('aria-hidden', 'false');
    filterToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeFilter() {
    filterDrawer.classList.remove('is-open');
    filterOverlay.classList.remove('is-open');
    filterDrawer.setAttribute('aria-hidden', 'true');
    filterToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (filterToggle) filterToggle.addEventListener('click', openFilter);
  if (filterClose) filterClose.addEventListener('click', closeFilter);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilter);

  if (filterForm) {
    filterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var params = [];
      var checkboxes = filterForm.querySelectorAll('input[type="checkbox"]:checked');
      checkboxes.forEach(function(cb) {
        params.push(encodeURIComponent(cb.name) + '=' + encodeURIComponent(cb.value));
      });
      var priceInputs = filterForm.querySelectorAll('.mc-filter-price-input');
      priceInputs.forEach(function(input) {
        if (input.value) {
          params.push(encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value));
        }
      });
      var url = window.location.pathname;
      if (params.length > 0) url += '?' + params.join('&');
      window.location.href = url;
    });
  }

  if (sortToggle && sortDropdown) {
    sortToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = sortDropdown.classList.toggle('is-open');
      sortToggle.setAttribute('aria-expanded', isOpen);
    });
    document.addEventListener('click', function(e) {
      if (!sortDropdown.contains(e.target) && e.target !== sortToggle) {
        sortDropdown.classList.remove('is-open');
        sortToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
